/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useReducer } from "react";
import { When } from "react-if";
import { PopoverControls } from "~/components";
import { isEmpty } from "~/tools";
import { AddToResourceGroup } from "./AddToGroup/AddToResourceGroup";

type State = {
  isAddToGroupModalOpen: boolean;
};

type Props = {
  resourcesDetails: {
    id: string;
  }[];
  onSuccess?: () => void;
  size?: "large" | "small";
};

export function Actions({ resourcesDetails, size = "small" }: Props) {
  const [state, updateState] = useReducer(
    (data: State, partialData: Partial<State>) => {
      return {
        ...data,
        ...partialData,
      };
    },
    { isAddToGroupModalOpen: false }
  );

  const resourcesIds = resourcesDetails.map((item) => item.id);
  const noResourcesIds = isEmpty(resourcesIds ?? []);
  return (
    <>
      <PopoverControls
        disabled={noResourcesIds}
        size={size}
        items={[
          {
            label: `Add to Resource Group`,
            onClick: () => updateState({ isAddToGroupModalOpen: true }),
          },
          {
            label: `Delete Resource`,
            onClick: () => {}, // Placeholder until delete is implemented
            disabled: true,
          },
        ]}
      />
      <When condition={state.isAddToGroupModalOpen}>
        <AddToResourceGroup
          {...{
            resourcesIds: resourcesIds,
            isOpen: state.isAddToGroupModalOpen,
          }}
          close={() => updateState({ isAddToGroupModalOpen: false })}
        />
      </When>
    </>
  );
}
